import React, { useState } from 'react';
import PageLoadingSpinner from '../components/PageLoadingSpinner';
import {
  TRADEMARK,
  TRADEMARK_ALT,
  TRADEMARK_CAPTION,
  TRADEMARK_FACTS,
  TRADEMARK_NOTE,
} from '../config/trademark';

/**
 * /copyright — Telif Hakkı ve Marka Tescili.
 *
 * Sayfa İKİ resmî belgeyi birden taşır: Kültür ve Turizm Bakanlığı telif kaydı
 * ve Türk Patent ve Marka Kurumu marka tescili. Rota `/copyright` KALDI (eski
 * bağlantılar kırılmasın); değişen yalnız başlık ve alt bilgideki etiket.
 *
 * Belgeler SAYFADA görünür, bağlantının arkasında değil (kullanıcı kararı
 * 14.09.2026). PDF indirme bağlantısı YOKTUR ve PDF `public/`e konmaz —
 * ziyaretçinin belgeyi indirmesine gerek yok. Marka künyesi
 * `config/trademark.js`ten gelir; Hakkımızda sayfası AYNI kaynaktan okur.
 */
function CopyrightPage() {
  const [loading] = useState(false);

  return (
    <>
      <PageLoadingSpinner show={loading} fullscreen />
      <div className="container py-5">
        <h2 className="mb-4">Telif Hakkı ve Marka Tescili</h2>
        <p>
          Katip Otomasyonu uzantısının ve web sitesinin tüm kodları, görselleri, dokümantasyonu ve marka hakları Arkaya Arge Yazılım İnşaat Ticaret Ltd.Şti.'ye aittir. Aşağıda yer alan Kültür ve Turizm Bakanlığı Telif Hakları Genel Müdürlüğü belgesi ile Türk Patent ve Marka Kurumu Marka Tescil Belgesi, telif ve marka haklarımızın resmi olarak tescillendiğini göstermektedir.
        </p>
        <p>
          Kodların, görsellerin ve dokümantasyonun izinsiz kopyalanması, dağıtılması veya değiştirilmesi yasaktır.
        </p>
        <p>
          Üçüncü parti kütüphaneler ilgili lisansları ile kullanılır ve bu lisanslara uyulur. Kullanıcılar, uzantıyı ve web sitesini yalnızca kendi kurumları için kullanabilir, ticari olarak satamaz, çoğaltamaz veya dağıtamaz. Katip Otomasyonu'nun marka ve telif hakları Arkaya Arge Yazılım İnşaat Ticaret Ltd.Şti.'nin izni olmadan kullanılamaz.
        </p>
        <p>
          Sitede yer alan ticari unvan, marka, logo, alan adı ve Katip Otomasyonu uzantısı ile benzeri diğer tüm unsur ve içeriklerin fikrî ve sınai mülkiyet hakları veya kullanım lisansı Arkaya Arge Yazılım İnşaat Ticaret Ltd.Şti.'ye aittir. Kullanıcıya yalnızca şahsi kullanım ile sınırlı, münhasır olmayan, devredilemez ve değiştirilemez bir kullanım lisansı verilmektedir. Sitenin tamamı veya bir kısmı ve Katip Otomasyonu uzantısı, herhangi bir yöntemle kopyalanamaz, çoğaltılamaz, dağıtılamaz, yayımlanamaz, ödünç verilemez, içeriği değiştirilemez veya tahrip edilemez.
        </p>
        <p className="mb-4">
          Detaylı bilgi için info@arkaya.com.tr adresine başvurabilirsiniz.
        </p>

        {/* ── Telif hakkı belgesi ─────────────────────────────────── */}
        <h3 className="h5 mt-5 mb-3 border-bottom pb-2">Telif Hakkı Belgesi</h3>
        <div className="text-center">
          <img
            src="/copyrigt.jpg"
            alt="Kültür ve Turizm Bakanlığı Telif Hakları Genel Müdürlüğü Belgesi"
            className="img-fluid rounded shadow"
            style={{ maxWidth: '800px', width: '100%', height: 'auto' }}
            loading="lazy"
          />
          <p className="mt-3 text-muted">
            <em>Kültür ve Turizm Bakanlığı Telif Hakları Genel Müdürlüğü'nden alınan resmi belge</em>
          </p>
        </div>

        {/* ── Marka tescili ───────────────────────────────────────── */}
        <h3 className="h5 mt-5 mb-3 border-bottom pb-2">Marka Tescili</h3>
        <p>{TRADEMARK_NOTE}</p>
        <ul className="list-unstyled mb-4">
          {TRADEMARK_FACTS.map(([label, value]) => (
            <li key={label}>
              <strong>{label}:</strong> {value}
            </li>
          ))}
        </ul>
        <div className="text-center">
          {/* Gerçek piksel ölçüsü yazılı: görsel yüklenirken sayfa zıplamasın. */}
          <img
            src={TRADEMARK.image}
            alt={TRADEMARK_ALT}
            className="img-fluid rounded shadow"
            width={TRADEMARK.imageWidth}
            height={TRADEMARK.imageHeight}
            style={{ maxWidth: '800px', width: '100%', height: 'auto' }}
            loading="lazy"
          />
          <p className="mt-3 text-muted">
            <em>{TRADEMARK_CAPTION}</em>
          </p>
        </div>
      </div>
    </>
  );
}

export default CopyrightPage;
